import { render } from "./Features.vue?vue&type=template&id=d8d9b0ce&ts=true"
import script from "./Features.vue?vue&type=script&lang=ts"
export * from "./Features.vue?vue&type=script&lang=ts"

import "./Features.vue?vue&type=style&index=0&id=d8d9b0ce&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__